import {
  Cascader,
  DatePicker,
  Button,
  Select,
  Table,
  Modal,
  Input,
  message,
} from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import "./index.styl";
import { freezeMember, test } from "../../../api/member";
import {
  getSmartBeanList,
  getSmartBeanDetailList,
  exportSmartBeansExelFile,
} from "../../../api/smartBeans";
const { RangePicker } = DatePicker;

export default function SmartBeansSearch() {
  // 本期暂时不做
  const searchContent = useRef("");
  const learnStatus = useRef("");
  const smartBeans = useRef(0);
  const [searchTime, setSearchTime] = useState("");

  // 智慧豆列表
  const pageNo = useRef(1);
  const startSearchBeans = useRef(0);
  const endSearchBeans = useRef(0);
  const [userNum, setUserNum] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [smartBeanList, setSmartBeanList] = useState([]);

  // 智慧豆详情列表
  const detailPageNo = useRef(1);
  const [smartBeanDetailList, setSmartBeanDetailList] = useState([]);

  useEffect(() => {
    async function getData() {
      onSearchBtnClicked();
    }

    getData();
  }, []);

  const columns = [
    {
      title: "称号",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "学号",
      dataIndex: "user_no",
      key: "user_no",
    },
    {
      title: "自然村",
      dataIndex: "natural_village",
      key: "natural_village",
      render: (_, recoder) => {
        return <span>{recoder?.natural_village ?? "-"}</span>;
      },
    },
    {
      title: "智慧豆",
      dataIndex: "bean_amount",
      key: "bean_amount",
      render: (_, recoder) => {
        console.log("recoder++++:", recoder);
        return (
          <Button onClick={() => onSmartBeansClicked(recoder)} type="link">
            {recoder?.bean_amount}
          </Button>
        );
      },
    },
  ];

  const [beansListTotalNum, setBeansListTotalNum] = useState(0);
  const [beansListCurPage, setBeansListCurPage] = useState(1);

  // 主列表分页属性
  const paginationProps = {
    // showSizeChanger: true,
    // showQuickJumper: true,
    showTotal: () => `共${beansListTotalNum}条`,
    pageSize: 10,
    current: beansListCurPage,
    total: beansListTotalNum,
    // onShowSizeChange: (current, pageSize) =>
    //   this.changePageSize(pageSize, current),
    onChange: (current) => onChangeBeansListpage(current),
  };

  const searchBeansList = useCallback(async () => {
    const left_of_bean_count = startSearchBeans.current;
    const right_of_bean_count = endSearchBeans.current;
    let params = { page_size: 10, page_no: pageNo.current };

    if (left_of_bean_count >= 0 && right_of_bean_count > 0) {
      params = { left_of_bean_count, right_of_bean_count, ...params };
    }

    if (userNum > "") {
      params.user_no = userNum;
    }

    const res = await getSmartBeanList(params);
    if (res.code == 0 && res.data && res.data.list?.length > 0) {
      setSmartBeanList(res.data.list);
      setBeansListTotalNum(res.data.count || 0);
    } else {
      setSmartBeanList([]);
    }
  }, [userNum]);

  const onChangeBeansListpage = useCallback(
    (current) => {
      setBeansListCurPage(current);
      pageNo.current = current;
      searchBeansList();
      // eslint-disable-next-line no-use-before-define
    },
    [searchBeansList]
  );

  const smartBeansDetail = [
    {
      title: "录入时间",
      dataIndex: "job_start_time",
      key: "job_start_time",
      render: (_, recoder) => {
        const time = recoder.job_start_time;
        let str = "-";
        const timeArr = time.split(" ");
        if (timeArr[0]) {
          const tempArr = timeArr[0].split("-");

          if (tempArr.length > 2) {
            str = `${tempArr[0]}年${tempArr[1]}月`;
          }
        }
        return <span>{str}</span>;
      },
    },
    {
      title: "板块",
      dataIndex: "main_department",
      key: "main_department",
    },
    {
      title: "子板块",
      dataIndex: "job",
      key: "job",
      render: (_, recoder) => {
        return <span>{recoder?.job > "" ? recoder?.job : "-"}</span>;
      },
    },
    // {
    //   title: "人物角色/内容",
    //   dataIndex: "role",
    //   key: "role",
    // },
    {
      title: "智慧豆",
      dataIndex: "bean_amount",
      key: "bean_amount",
      render: (_, recoder) => {
        return (
          <span>
            {recoder?.type == 1
              ? `${recoder.bean_amount}`
              : `-${recoder.bean_amount}`}
          </span>
        );
      },
    },
  ];

  /**
   * 智慧豆列表查询
   */
  const onSearchBtnClicked = useCallback(async () => {
    pageNo.current = 1;
    setBeansListCurPage(1);
    searchBeansList();
  }, [searchBeansList]);

  const [beansDetailListTotalNum, setBeansDetailListTotalNum] = useState(0);
  const [beansDetailListCurPage, setBeansDetailListCurPage] = useState(1);
  const rowRecordData = useRef({});

  const searchBeansDetailList = useCallback(async () => {
    const params = {
      page_no: detailPageNo.current,
      page_size: 10,
      user_no: rowRecordData.current.user_no || "",
    };

    const res = await getSmartBeanDetailList(params);
    if (res && res.code == 0 && res.data.list.length > 0) {
      setSmartBeanDetailList(res.data.list);
      setBeansDetailListTotalNum(res.data.count);
    }
  }, []);

  const onChangeBeansDetailListpage = useCallback(
    (current) => {
      setBeansDetailListCurPage(current);
      detailPageNo.current = current;
      searchBeansDetailList();
      // eslint-disable-next-line no-use-before-define
    },
    [searchBeansDetailList]
  );

  // 智慧豆详情分页属性
  const paginationPropsBeansDetail = {
    // showSizeChanger: true,
    // showQuickJumper: true,
    showTotal: () => `共${beansDetailListTotalNum}条`,
    pageSize: 10,
    current: beansDetailListCurPage,
    total: beansDetailListTotalNum,
    // onShowSizeChange: (current, pageSize) =>
    //   this.changePageSize(pageSize, current),
    onChange: (current) => onChangeBeansDetailListpage(current),
  };

  const onSmartBeansClicked = useCallback(async (rowData) => {
    console.log("rowData:", rowData);
    rowRecordData.current = rowData || {};
    await searchBeansDetailList();
    setShowModal(true);
  }, []);

  const onUserNumChanged = useCallback((e) => {
    setUserNum(e.target.value);
  }, []);

  const onStartSearchBeansChanged = useCallback((e) => {
    startSearchBeans.current = e.target.value;
  }, []);

  const onEndSearchBeansChanged = useCallback((e) => {
    endSearchBeans.current = e.target.value;
  }, []);

  const onDownLoadBtnClicked = useCallback(async () => {
    const left_of_bean_count = startSearchBeans.current;
    const right_of_bean_count = endSearchBeans.current;
    let params = {};
    if (left_of_bean_count >= 0 && right_of_bean_count > 0) {
      params = { left_of_bean_count, right_of_bean_count, ...params };
    }

    if (userNum > "") {
      params.user_no = userNum;
    }

    const res = await exportSmartBeansExelFile(params);
    if (res && res.code == 0) {
      message.success("下载成功！");
    } else {
      message.error("下载失败！");
    }
  }, [userNum]);

  return (
    <div className="container">
      <div className="searchContainer">
        <div className="searchInputContainer">
          {/* <div className="searchItem">
            内容搜索：
            <Cascader
              onChange={onSearchContentChanged}
              options={options}
              placeholder="Please select"
            />
          </div> */}
          {/* <div className="searchItem">
            时间范围：
            <RangePicker
              format="YYYY-MM-DD"
              onChange={(value, dateString) => {
                console.log("Selected Time: ", value);
                console.log("Formatted Selected Time: ", dateString);
              }}
              onOk={onSearchTimeChanged}
            />
          </div> */}
          {/* <Button className="searchItem" type="primary">
            近7天
          </Button>
          <Button className="searchItem" type="primary">
            近30天
          </Button> */}
          {/* <div className="searchItem">
            学习状态：
            <Select
              defaultValue="lucy"
              style={{ width: 120 }}
              onChange={onLearnStatusChanged}
              options={[
                { value: "jack", label: "Jack" },
                { value: "lucy", label: "Lucy" },
                { value: "Yiminghe", label: "yiminghe" },
                { value: "disabled", label: "Disabled", disabled: true },
              ]}
            />
          </div> */}
          <div className="searchItem">
            学号：
            <Input
              onChange={onUserNumChanged}
              style={{ height: 32, width: 160 }}
            />
          </div>
          <div className="searchItem">
            智慧豆范围：
            <Input
              onChange={onStartSearchBeansChanged}
              style={{ height: 32, width: 160, marginRight: 12 }}
            />
            -
            <Input
              onChange={onEndSearchBeansChanged}
              style={{ height: 32, width: 160, marginLeft: 12 }}
            />
          </div>
          {/* <div className="searchItem">
            智慧豆：
            <Select
              defaultValue={0}
              style={{ width: 120 }}
              onChange={onSmartBeansChanged}
              options={[
                { value: "10", label: "10" },
                { value: "20", label: "20" },
                { value: "30", label: "30" },
              ]}
            />
          </div> */}
        </div>

        <div className="btnContainer">
          <Button
            style={{ marginTop: 20 }}
            className="searchItem"
            type="primary"
            onClick={() => {
              onSearchBtnClicked();
              // test();
              // freezeMember("BJ2407028", 1);
            }}
          >
            查询
          </Button>
          <Button
            onClick={onDownLoadBtnClicked}
            style={{ marginTop: 20 }}
            className="searchItem"
            type="link"
          >
            下载列表Excel
          </Button>
        </div>
      </div>

      <div className="contentContainer">
        <Table
          pagination={paginationProps}
          onRow={(record) => {
            console.log(record);
            return {
              onClick: (event) => {
                console.log("smart beans", event);
              },
            };
          }}
          dataSource={smartBeanList}
          columns={columns}
        />
      </div>

      <Modal
        title="智慧豆详细列表"
        open={showModal}
        width={1000}
        onCancel={() => {
          setShowModal(false);
        }}
        footer={null}
      >
        <Table
          pagination={paginationPropsBeansDetail}
          onRow={(record) => {
            console.log(record);
            return {
              onClick: (event) => {
                console.log(event);
              },
            };
          }}
          dataSource={smartBeanDetailList}
          columns={smartBeansDetail}
        />
      </Modal>
    </div>
  );
}
